import { CharacterRef } from '../../types/typing.ts';

import { gsap } from 'gsap';

class LottieControl {
  cacheMap: Record<string, CharacterRef> = {};

  enter(data: {
    id: string;
    src: string;
    startTime: number;
    endTime: number;
    time: number;
    characterRef: any;
  }) {
    const { id, characterRef } = data;
    let item: CharacterRef;

    if (this.cacheMap[id]) {
      item = this.cacheMap[id];
      item.sprite.visible = true;
    } else {
      characterRef.current.forEach((ref: CharacterRef) => {
        if (ref.id === id) {
          ref.sprite.visible = true;
          this.cacheMap[id] = ref;
        }
      });
    }
  }

  update(data: {
    id: string;
    src: string;
    startTime: number;
    endTime: number;
    time: number;
    characterRef: any;
  }) {
    const { id, startTime, endTime, time } = data;
    const item = this.cacheMap[id];

    if (!item) return;
    if (item.pathPoints.length > 0) {
      // Calculate progress ratio based on current time
      const duration = endTime - startTime;
      const currentTime = time - startTime;
      const progress = Math.max(0, Math.min(1, currentTime / duration));

      // Clear any existing GSAP animations for this sprite
      gsap.killTweensOf(item.sprite);

      // Create a timeline for smooth animation
      //const timeline = gsap.timeline();

      // Calculate total path length for even distribution
      const totalPoints = item.pathPoints.length;
      //const segmentDuration = duration / (totalPoints - 1);

      // Calculate which segment we should be on
      const currentSegmentIndex = Math.floor(progress * (totalPoints - 1));
      const nextSegmentIndex = Math.min(
        currentSegmentIndex + 1,
        totalPoints - 1
      );

      // Calculate sub-progress within current segment
      const segmentProgress = (progress * (totalPoints - 1)) % 1;

      // Get current and next points
      const currentPoint = item.pathPoints[currentSegmentIndex];
      const nextPoint = item.pathPoints[nextSegmentIndex];

      // Interpolate position
      const currentX =
        currentPoint.x + (nextPoint.x - currentPoint.x) * segmentProgress;
      const currentY =
        currentPoint.y + (nextPoint.y - currentPoint.y) * segmentProgress;

      // Update sprite position immediately
      gsap.set(item.sprite, {
        x: currentX,
        y: currentY,
        onUpdate: () => {
          item.sprite.position.x = currentX;
          item.sprite.position.y = currentY;
        },
      });
    }
  }

  leave(data: {
    id: string;
    startTime: number;
    endTime: number;
    time: number;
    characterRef: any;
  }) {
    const { id, startTime, endTime, time, characterRef } = data;
    if (!this.cacheMap[id]) {
      characterRef.current.forEach((ref: CharacterRef) => {
        if (ref.id === id) {
          this.cacheMap[id] = ref;
        }
      });
    }
    const item = this.cacheMap[id];
    if (!item) return;
    if (time > endTime || time < startTime) {
      item.sprite.visible = false;
    } else {
      //const cur = time - startTime;
      item.sprite.visible = true;
      //this._goToAndStop(item, cur);
    }
  }

  destroy() {
    this.cacheMap = {};
  }
}

export default new LottieControl();
